import * as React from 'react'
import NumberFieldInnerTable from '../../inputs/NumberFieldInnerTable'

const NettoOptions = ({ data, setData }) => {
React.useEffect(() => {
  if (data?.nettoType !== 2 && 'additionalNettoRate' in data) {
    const { additionalNettoRate, ...rest } = data
    setData(rest)
  }
}, [data])

  return (
    <div
      className={`tw-my-1 tw-flex tw-flex-col tw-items-start tw-gap-2 tw-rounded tw-bg-[#f2f2f2]/50 tw-p-4 tw-px-2`}
    >
      {data?.nettoType === 2 ? (
        <>
          <NumberFieldInnerTable
            inputSize="big"
            label="Stawka krajowa"
            fullWidth
            innerLabel="PLN"
            placeholder="0,00"
            value={data.contractNettoRate?.toString()}
            onChange={(e) => {
              setData({
                ...data,
                contractNettoRate: Number(e.target.value),
              })
            }}
          />
          <NumberFieldInnerTable
            inputSize="big"
            label="Stawka zagraniczna"
            fullWidth
            innerLabel="PLN"
            placeholder="0,00"
            value={data.additionalNettoRate?.toString()}
            onChange={(e) => {
              setData({
                ...data,
                additionalNettoRate: Number(e.target.value),
              })
            }}
          />
        </>
      ) : (
        <>
          <NumberFieldInnerTable
            inputSize="big"
            label="Stawka"
            fullWidth
            innerLabel="PLN"
            placeholder="0,00"
            value={data.contractNettoRate?.toString()}
            onChange={(e) => {
              setData({
                ...data,
                contractNettoRate: Number(e.target.value),
              })
            }}
          />
        </>
      )}
    </div>
  )
}

export default NettoOptions
